import React, { useState, useRef, useEffect } from 'react'
import styles from './CustomCheckDropDown.module.css';
export default function CustomCheckDropDown({ list, onSelect, isSelected, displayKey, label }) {
    const [isOpen, setIsOpen] = useState(false)
    const dialogBox = useRef(null);
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };
    const handleSelect = (option) => {
        onSelect(option);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dialogBox.current && !dialogBox.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    return (
        <div ref={dialogBox} className={styles.dropdown}>
            <div className={styles.lettertype} onClick={handleToggle} style={{ cursor: "pointer" }}>
                <div className={`${styles.selectItem} ${isSelected ? styles.selected : ''}`}>
                    <p>{isSelected ? `Selected(${list.filter(i => i.checked).length})` : label}</p>
                    {isOpen ? <img src='/chevrondown.svg' style={{ transform: "rotate(180deg)" }} /> : <img src='/chevrondown.svg' />}
                </div>
            </div>

            <div className={styles.customDropdown}>
                {isOpen && (
                    <div className={styles.dropdownOptions}>
                        {list.map((i, index) => (
                            <div key={index} className={styles.dropdownList} onClick={() => handleSelect(displayKey ? index : i)}>
                                <input type="checkbox" checked={i?.checked} className={styles.checkbox} />
                                {displayKey ? i[displayKey] : i}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}
